module.exports = __webpack_public_path__ + "static/media/cn.3a5b5ac1.svg";